import React from "react";
import { ColumnHeader } from "@/components/molecules/column_header/ColumnHeader";
import { cn } from "@/lib/utils";

interface ColumnProps {
  className?: string;
  headerStyle?: string;
  headerRight?: React.ReactNode;
  columnData: {
    name: string;
    description: string | null;
  };
  editable?: boolean;
  onNameSave?: (value: string) => void;
  onDescriptionSave?: (value: string) => void;
}

export const Column: React.FC<React.PropsWithChildren<ColumnProps>> = ({
  className,
  children,
  headerStyle,
  headerRight,
  columnData,
  editable,
  onNameSave,
  onDescriptionSave,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col items-stretch gap-3 min-w-[280px] px-1 py-3 h-full",
        className,
      )}
    >
      <div className={cn("flex items-end", headerStyle)}>
        <ColumnHeader
          header={columnData.name}
          description={columnData.description ?? undefined}
          right={headerRight}
          editable={editable}
          onHeaderSave={onNameSave}
          onDescriptionSave={onDescriptionSave}
        />
      </div>
      {children}
    </div>
  );
};
